"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _kycLevelsSelectors = require("../../../redux/selectors/kycLevelsSelectors");
var _kycJumioActions = require("../../../redux/actions/kycJumioActions");
var _sidePaneActions = require("../../../redux/actions/sidePaneActions");
var _KYC_JumioIframeComponent = _interopRequireDefault(require("./KYC_JumioIframeComponent"));
var _getLevelHelper = require("../../../helpers/getLevelHelper");
var _snackbarActions = require("../../../redux/actions/snackbarActions");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var mapStateToProps = function mapStateToProps(state) {
  var _kycLevelFormSelector = (0, _kycLevelsSelectors.kycLevelFormSelector)(state),
    verificationLevel = _kycLevelFormSelector.verificationLevel,
    kycConfig = _kycLevelFormSelector.kycConfig,
    kyc = _kycLevelFormSelector.kyc,
    alphaPointSessiontoken = _kycLevelFormSelector.alphaPointSessiontoken,
    alphaPointUserID = _kycLevelFormSelector.alphaPointUserID,
    userConfig = _kycLevelFormSelector.userConfig,
    userName = _kycLevelFormSelector.userName,
    processing = _kycLevelFormSelector.processing;
  var level = (0, _getLevelHelper.getDisplayLevel)(kycConfig, verificationLevel + 1);
  return {
    level: level,
    processing: processing,
    alphaPointUserID: alphaPointUserID,
    alphaPointSessiontoken: alphaPointSessiontoken,
    kycConfig: kycConfig,
    userName: userName,
    kyc: kyc,
    userConfig: userConfig
  };
};
var mapDispatchToProps = {
  validateUserRegistration: _kycJumioActions.validateUserRegistration,
  closeKYC_JumioSidePane: _sidePaneActions.closeKYC_JumioSidePane,
  showSnack: _snackbarActions.showSnack
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_KYC_JumioIframeComponent["default"]);